import { Injectable } from '@angular/core';
import { RumInit } from '@maersk-global/telemetry-web-sdk'
import {ConfigService} from './_services/config.service';
import { Faro } from "@grafana/faro-web-sdk";

@Injectable({
  providedIn: 'root'
})
export class MopService {
  faro: Faro

  private envKey = {
    cdt: 'zghMGjrIvYK7TcJWqRCbTBkOr7MTFfPDkkspFGAyAtvPZFlEOxQ5/9OdeL9iqA==',
    stage: 'OVUuPJOKNxYDSdmVP9joabkPz2Iwin3w+25hEDxaB/dJr1QPg0vUvDB3qQTnHQ==',
    prod: 'K1PmC0ipVExOczHvJYFl2kkX+v1hI91LU7YYPwsXmV3FyxE1WxXsmoB6Oxr7pg==',
  }

  constructor(
    private configService: ConfigService
  ) {}

  get loginStartTimeOrigin(): number | undefined {
    const value = localStorage.getItem('startTimeStamp');
    return value ? parseFloat(value) : undefined;
  }

  set loginStartTimeOrigin(value: number) {
    localStorage.setItem('startTimeStamp', value.toString());
  }


  initializeTelemetry() {
    const env = this.configService.getCurrentEnv()
    this.faro = RumInit({
      app: {
        name: `portalcabotagem2-${env}`,
        version: this.configService._config.version,
        environment: env,
      },
      apiKey: this.envKey[env],
      performanceInstrument: {ignoreEvents: ['msal.*']},
      useSendBeacon: true,
    })
  }

  setUser(id: string, email: string) {
   this.faro.api.setUser({id, email})
  }

  resetUser() {
    this.faro.api.resetUser()
  }
}
